import {matchPath} from "react-router-dom";

export const deriveLocaleFromLocation = (location) => matchPath(
    location.pathname,
    "/:lng"
)?.params?.lng